import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ListItem from 'components/atoms/Lists/ListItem/ListItem';

const StyledPeriodUpdateListItem = styled(ListItem)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  row-gap: ${props => props.theme.layout('1sp')};
  padding: ${props => props.theme.spacing(3)} 0;
  
  .PeriodUpdateListItem {
    &-avatar {
      width: ${props => props.theme.layout(56)};
      height: ${props => props.theme.layout(56)};
    }
    
    &-content {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: ${props => props.theme.layout('1sp')};
      padding-left: ${props => props.theme.spacing(2)};
    }
    
    &-text {
      margin: 0;
      .MuiListItemText-primary {
        ${props => props.theme.font2Css('h3')};
        line-height: ${props => props.theme.lineHeight('1.285f')};
        color: ${props => props.theme.property('palette.primary.main')};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledPeriodUpdateListItem.propTypes = {
  theme: PropTypes.object
};

export default StyledPeriodUpdateListItem;
